import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4e435c9e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "word-detail-modal__header word-detail-modal__header--blocked"
}
const _hoisted_2 = { class: "word-detail-modal__content word-detail-modal__content--blocked" }
const _hoisted_3 = { class: "word-detail-modal__blocked-title" }
const _hoisted_4 = { class: "word-detail-modal__meta" }
const _hoisted_5 = { class: "word-detail-modal__timestamp" }
const _hoisted_6 = {
  key: 1,
  class: "word-detail-modal__header"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M15.8327 9.99999H4.16602M4.16602 9.99999L9.99935 15.8333M4.16602 9.99999L9.99935 4.16666",
    stroke: "#475467",
    "stroke-width": "1.66667",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = { class: "word-detail-modal__content" }
const _hoisted_10 = { class: "word-detail-modal__title" }
const _hoisted_11 = { class: "word-detail-modal__title-label" }
const _hoisted_12 = { class: "word-detail-modal__word" }
const _hoisted_13 = { class: "word-detail-modal__meta" }
const _hoisted_14 = { class: "word-detail-modal__timestamp" }
const _hoisted_15 = { class: "answer-review" }
const _hoisted_16 = {
  key: 0,
  class: "answer-review__body answer-review__body--blocked"
}
const _hoisted_17 = {
  key: 0,
  class: "answer-review__attempt-focus"
}
const _hoisted_18 = { class: "answer-review__section-title answer-review__section-title--blocked" }
const _hoisted_19 = { class: "answer-review__question-card answer-review__question-card--blocked" }
const _hoisted_20 = ["innerHTML"]
const _hoisted_21 = {
  key: 1,
  class: "answer-review__question-text"
}
const _hoisted_22 = {
  key: 2,
  class: "answer-review__details"
}
const _hoisted_23 = { class: "answer-review__detail-term" }
const _hoisted_24 = ["innerHTML"]
const _hoisted_25 = {
  key: 1,
  class: "answer-review__detail-value"
}
const _hoisted_26 = { class: "answer-review__section answer-review__section--tight" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "answer-review__section-title answer-review__section-title--regular" }, " Student’s answer: ", -1))
const _hoisted_28 = { class: "answer-review__option-text" }
const _hoisted_29 = {
  key: 0,
  class: "answer-review__section answer-review__section--tight"
}
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "answer-review__section-title answer-review__section-title--regular" }, " Correct answer: ", -1))
const _hoisted_31 = { class: "answer-review__answer-card answer-review__answer-card--correct" }
const _hoisted_32 = { class: "answer-review__option-text" }
const _hoisted_33 = {
  key: 1,
  class: "answer-review__body"
}
const _hoisted_34 = { class: "answer-review__section" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "answer-review__section-title" }, "Question:", -1))
const _hoisted_36 = { class: "answer-review__question-card" }
const _hoisted_37 = ["innerHTML"]
const _hoisted_38 = {
  key: 1,
  class: "answer-review__question-text"
}
const _hoisted_39 = {
  key: 2,
  class: "answer-review__details"
}
const _hoisted_40 = { class: "answer-review__detail-term" }
const _hoisted_41 = ["innerHTML"]
const _hoisted_42 = {
  key: 1,
  class: "answer-review__detail-value"
}
const _hoisted_43 = {
  key: 3,
  class: "answer-review__options-list"
}
const _hoisted_44 = { class: "answer-review__option-bullet" }
const _hoisted_45 = { class: "answer-review__option-value" }
const _hoisted_46 = {
  key: 4,
  class: "answer-review__options-grid"
}
const _hoisted_47 = { class: "answer-review__option-bullet" }
const _hoisted_48 = { class: "answer-review__option-value" }
const _hoisted_49 = { class: "answer-review__section" }
const _hoisted_50 = { class: "answer-review__section-title" }
const _hoisted_51 = {
  key: 0,
  class: "answer-review__section-sub answer-review__section-sub--correct"
}
const _hoisted_52 = ["innerHTML"]
const _hoisted_53 = {
  key: 1,
  class: "answer-review__sentence-text"
}
const _hoisted_54 = {
  key: 0,
  class: "answer-review__option-label"
}
const _hoisted_55 = { class: "answer-review__option-text" }
const _hoisted_56 = {
  key: 0,
  class: "answer-review__section"
}
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "answer-review__section-title" }, "Correct answer:", -1))
const _hoisted_58 = {
  key: 0,
  class: "answer-review__sentence-card answer-review__sentence-card--correct"
}
const _hoisted_59 = ["innerHTML"]
const _hoisted_60 = {
  key: 1,
  class: "answer-review__sentence-text"
}
const _hoisted_61 = {
  key: 1,
  class: "answer-review__answer-card answer-review__answer-card--correct"
}
const _hoisted_62 = {
  key: 0,
  class: "answer-review__option-label"
}
const _hoisted_63 = { class: "answer-review__option-text" }
const _hoisted_64 = {
  key: 0,
  class: "answer-review__blocked-footer"
}
const _hoisted_65 = { class: "answer-review__blocked-nav" }
const _hoisted_66 = ["disabled"]
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M12.5 15L7.5 10L12.5 5",
    stroke: "currentColor",
    "stroke-width": "1.67",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1))
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Previous", -1))
const _hoisted_69 = [
  _hoisted_67,
  _hoisted_68
]
const _hoisted_70 = { class: "answer-review__blocked-counter" }
const _hoisted_71 = ["disabled"]
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Next", -1))
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M7.5 15L12.5 10L7.5 5",
    stroke: "currentColor",
    "stroke-width": "1.67",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1))
const _hoisted_74 = [
  _hoisted_72,
  _hoisted_73
]

import { computed, ref, watch } from "vue";
import LingoModal from "@/modules/main/components/manage/LingoModalComponent.vue";

const DEFAULT_BLOCKED_TOTAL_QUESTIONS = 10;

interface ReviewDetail {
    label: string;
    value: string;
    isHtml?: boolean;
}

interface BlockedAttemptReview {
    attemptNumber?: number;
    isCorrect?: boolean;
    timestamp?: string;
    questionText?: string;
    questionHtml?: string;
    questionDetails?: ReviewDetail[];
    studentAnswer?: string;
    correctAnswer?: string;
}

interface TeacherBotLike {
    id?: string;
    name?: string;
    avatar?: string | null;
    voice?: string | null;
}

interface ReviewData {
    statusTitle?: string;
    timestamp?: string;
    word?: string;
    itemCategory?: string;
    type?: string;
    isCorrect?: boolean;
    questionText?: string;
    questionHtml?: string;
    questionDetails?: Array<{ label: string; value: string; isHtml?: boolean }>;
    options?: Array<any>;
    selectedIndex?: number;
    correctIndex?: number;
    studentAnswer?: string;
    studentSentence?: string;
    studentSentenceHtml?: string;
    studentAnswerSentenceHtml?: string;
    studentSentenceText?: string;
    studentAnswerSentence?: string;
    studentSentencePlain?: string;
    correctAnswer?: string;
    correctSentence?: string;
    correctSentenceHtml?: string;
    correctAnswerSentenceHtml?: string;
    correctSentenceText?: string;
    correctAnswerSentence?: string;
    correctSentencePlain?: string;
    isBlockedAggregate?: boolean;
    blockedAttempts?: BlockedAttemptReview[];
    blockedTotalQuestions?: number;
    blockedAggregateLabel?: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AnswerReviewModal',
  props: {
    modelValue: { type: Boolean },
    review: {},
    teacherBot: {}
  },
  emits: ["update:modelValue", "close", "open-full-explanation"],
  setup(__props: any, { emit }) {

const props = __props;

const ALPHABET = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");




const internalValue = computed({
    get() {
        return props.modelValue;
    },
    set(next: boolean) {
        emit("update:modelValue", next);
    }
});

const formattedTimestamp = computed(() => {
    return props.review?.timestamp || "";
});

const displayWord = computed(() => {
    return props.review?.word || "";
});

const itemCategory = computed(() => {
    return props.review?.itemCategory || "cloze";
});

const activityType = computed(() => {
    return props.review?.type || "vocabulary";
});

const wordLabel = computed(() => {
    return activityType.value === "vocabulary" ? "Know the word:" : "Spell the word:";
});

const isBlockedAggregateReview = computed(() => {
    return props.review?.isBlockedAggregate === true;
});

const blockedAttempts = computed(() => {
    if (!Array.isArray(props.review?.blockedAttempts)) {
        return [];
    }
    return props.review.blockedAttempts
        .filter((attempt: BlockedAttemptReview) => attempt && typeof attempt === "object")
        .map((attempt: BlockedAttemptReview, index: number) => ({
            ...attempt,
            attemptNumber: Number(attempt.attemptNumber) > 0 ? Number(attempt.attemptNumber) : index + 1
        }));
});

const blockedAttemptIndex = ref(0);

const blockedTotalQuestions = computed(() => {
    const configured = Number(props.review?.blockedTotalQuestions);
    if (Number.isFinite(configured) && configured > 0) {
        return configured;
    }
    return blockedAttempts.value.length || DEFAULT_BLOCKED_TOTAL_QUESTIONS;
});

const blockedAggregateTitle = computed(() => {
    if (typeof props.review?.blockedAggregateLabel === "string" && props.review.blockedAggregateLabel.trim().length) {
        return props.review.blockedAggregateLabel.trim();
    }
    return `Blocked Practice (x${blockedTotalQuestions.value})`;
});

const blockedAttemptCount = computed(() => blockedAttempts.value.length);

const currentBlockedAttempt = computed(() => {
    if (!blockedAttemptCount.value) return null;
    const safeIndex = Math.max(0, Math.min(blockedAttemptIndex.value, blockedAttemptCount.value - 1));
    return blockedAttempts.value[safeIndex];
});

const blockedDisplayIndex = computed(() => {
    if (!blockedAttemptCount.value) return 1;
    return Math.max(1, Math.min(blockedAttemptIndex.value + 1, blockedAttemptCount.value));
});

const canGoPrev = computed(() => blockedAttemptCount.value > 0 && blockedAttemptIndex.value > 0);

const canGoNext = computed(
    () => blockedAttemptCount.value > 0 && blockedAttemptIndex.value < blockedAttemptCount.value - 1
);

const resetBlockedAttemptIndex = () => {
    blockedAttemptIndex.value = 0;
};

const clampBlockedAttemptIndex = () => {
    if (!blockedAttemptCount.value) {
        blockedAttemptIndex.value = 0;
        return;
    }
    blockedAttemptIndex.value = Math.max(0, Math.min(blockedAttemptIndex.value, blockedAttemptCount.value - 1));
};

watch(
    () => props.modelValue,
    isOpen => {
        if (isOpen && isBlockedAggregateReview.value) {
            resetBlockedAttemptIndex();
        }
    }
);

watch(blockedAttemptCount, () => {
    clampBlockedAttemptIndex();
});

const isAnswerCorrect = computed(() => {
    if (isBlockedAggregateReview.value && currentBlockedAttempt.value) {
        return currentBlockedAttempt.value.isCorrect === true;
    }
    return props.review?.isCorrect === true;
});

const questionText = computed(() => {
    const source = isBlockedAggregateReview.value && currentBlockedAttempt.value
        ? currentBlockedAttempt.value
        : props.review;
    if (source && Object.prototype.hasOwnProperty.call(source, "questionText")) {
        return typeof source.questionText === "string" ? source.questionText : "";
    }
    return "Review the question details below.";
});

const showQuestionText = computed(() => {
    if (itemCategory.value === "audio") {
        return false;
    }
    const source = isBlockedAggregateReview.value && currentBlockedAttempt.value
        ? currentBlockedAttempt.value
        : props.review;
    if (source && Object.prototype.hasOwnProperty.call(source, "questionText")) {
        const value = source.questionText;
        return typeof value === "string" && value.trim().length > 0;
    }
    return true;
});

const questionHtml = computed(() => {
    const source = isBlockedAggregateReview.value && currentBlockedAttempt.value
        ? currentBlockedAttempt.value
        : props.review;
    return source?.questionHtml || "";
});

const shouldRenderQuestionHtml = computed(() => {
    return Boolean(questionHtml.value && questionHtml.value.trim().length);
});

const questionDetails = computed(() => {
    const source = isBlockedAggregateReview.value && currentBlockedAttempt.value
        ? currentBlockedAttempt.value
        : props.review;
    return Array.isArray(source?.questionDetails) ? source.questionDetails : [];
});

const optionEntries = computed(() => {
    const source = isBlockedAggregateReview.value && currentBlockedAttempt.value
        ? currentBlockedAttempt.value
        : props.review;
    if (!source || !Array.isArray(source.options)) {
        return [];
    }
    return source.options.map((option: any, index: number) => {
        if (option && typeof option === "object") {
            const textCandidate =
                typeof option.text === "string" && option.text.trim().length
                    ? option.text.trim()
                    : typeof option.value === "string" && option.value.trim().length
                        ? option.value.trim()
                        : typeof option.label === "string" && option.label.trim().length
                            ? option.label.trim()
                            : String(option);
            const id = option.id != null ? option.id : index;
            const metaValue = Object.prototype.hasOwnProperty.call(option, "meta") ? option.meta : option;
            return { id, text: textCandidate, meta: metaValue };
        }
        const text = typeof option === "string" ? option : String(option);
        return { id: index, text, meta: null };
    });
});

const optionTexts = computed(() => {
    return optionEntries.value.map((entry: any) => entry.text);
});

const selectedIndex = computed(() => {
    const source = isBlockedAggregateReview.value && currentBlockedAttempt.value
        ? currentBlockedAttempt.value
        : props.review;
    return source && typeof source.selectedIndex === "number" ? source.selectedIndex : null;
});

const correctIndex = computed(() => {
    const source = isBlockedAggregateReview.value && currentBlockedAttempt.value
        ? currentBlockedAttempt.value
        : props.review;
    return source && typeof source.correctIndex === "number" ? source.correctIndex : null;
});

const selectedIndexSafe = computed(() => {
    if (selectedIndex.value == null) return null;
    if (selectedIndex.value < 0 || selectedIndex.value >= optionEntries.value.length) return null;
    return selectedIndex.value;
});

const correctIndexSafe = computed(() => {
    if (correctIndex.value == null) return null;
    if (correctIndex.value < 0 || correctIndex.value >= optionEntries.value.length) return null;
    return correctIndex.value;
});

const hasOptions = computed(() => {
    return optionEntries.value.length > 0;
});

function optionPrefix(index: number, meta: any = null): string {
    const labelFromMeta = metaPrefix(meta);
    const baseLabel = labelFromMeta || ALPHABET[index] || "?";
    return baseLabel.endsWith(")") ? baseLabel : `${baseLabel})`;
}

function metaPrefix(meta: any): string {
    if (!meta || typeof meta !== "object") return "";
    const keys = ["displayLabel", "display", "letter", "label", "optionLabel", "MC option", "prefix"];
    for (const key of keys) {
        const value = meta[key];
        if (typeof value === "string" && value.trim().length) {
            const sanitized = value.trim().replace(/\)+$/, "");
            const letterMatch = sanitized.match(/[A-Z]$/i);
            if (letterMatch) {
                return letterMatch[0].toUpperCase();
            }
            return sanitized.toUpperCase();
        }
    }
    return "";
}

const optionStates = computed(() => {
    return optionEntries.value.map((entry: any, index: number) => ({
        id: entry.id != null ? entry.id : index,
        text: entry.text,
        prefix: optionPrefix(index, entry.meta)
    }));
});

const useClozeStudentSentence = computed(() => {
    return itemCategory.value === "cloze" && Boolean(studentSentenceHtml.value || studentSentenceText.value);
});

const studentSentenceHtml = computed(() => {
    const source = isBlockedAggregateReview.value && currentBlockedAttempt.value
        ? currentBlockedAttempt.value
        : props.review;
    const candidates = [
        source?.studentSentence,
        source?.studentSentenceHtml,
        source?.studentAnswerSentenceHtml
    ];
    const found = candidates.find((value) => typeof value === "string" && value.length);
    return found || "";
});

const studentSentenceText = computed(() => {
    const source = isBlockedAggregateReview.value && currentBlockedAttempt.value
        ? currentBlockedAttempt.value
        : props.review;
    const candidates = [
        source?.studentSentenceText,
        source?.studentAnswerSentence,
        source?.studentSentencePlain
    ];
    const found = candidates.find((value) => typeof value === "string" && value.length);
    return found || "";
});

const studentAnswer = computed(() => {
    const source = isBlockedAggregateReview.value && currentBlockedAttempt.value
        ? currentBlockedAttempt.value
        : props.review;
    if (source && typeof source.studentAnswer === "string" && source.studentAnswer.length) {
        return source.studentAnswer;
    }
    if (selectedIndexSafe.value != null) {
        return optionTexts.value[selectedIndexSafe.value] || "—";
    }
    return "—";
});

const useClozeCorrectSentence = computed(() => {
    return itemCategory.value === "cloze" && Boolean(correctSentenceHtml.value || correctSentenceText.value);
});

const correctSentenceHtml = computed(() => {
    const source = isBlockedAggregateReview.value && currentBlockedAttempt.value
        ? currentBlockedAttempt.value
        : props.review;
    const candidates = [
        source?.correctSentence,
        source?.correctSentenceHtml,
        source?.correctAnswerSentenceHtml
    ];
    const found = candidates.find((value) => typeof value === "string" && value.length);
    return found || "";
});

const correctSentenceText = computed(() => {
    const source = isBlockedAggregateReview.value && currentBlockedAttempt.value
        ? currentBlockedAttempt.value
        : props.review;
    const candidates = [
        source?.correctSentenceText,
        source?.correctAnswerSentence,
        source?.correctSentencePlain
    ];
    const found = candidates.find((value) => typeof value === "string" && value.length);
    return found || "";
});

const correctAnswer = computed(() => {
    const source = isBlockedAggregateReview.value && currentBlockedAttempt.value
        ? currentBlockedAttempt.value
        : props.review;
    if (source && typeof source.correctAnswer === "string" && source.correctAnswer.length) {
        return source.correctAnswer;
    }
    if (correctIndexSafe.value != null) {
        return optionTexts.value[correctIndexSafe.value] || "—";
    }
    return "—";
});

const studentPrefix = computed(() => {
    if (selectedIndexSafe.value == null) return null;
    const state = optionStates.value[selectedIndexSafe.value];
    return state ? state.prefix : null;
});

const correctPrefix = computed(() => {
    if (correctIndexSafe.value == null) return null;
    const state = optionStates.value[correctIndexSafe.value];
    return state ? state.prefix : null;
});

const showStudentPrefix = computed(() => {
    return false;
});

const showCorrectPrefix = computed(() => {
    return false;
});

const studentAnswerCardClass = computed(() => {
    return [
        "answer-review__answer-card",
        isAnswerCorrect.value ? "answer-review__answer-card--correct" : "answer-review__answer-card--incorrect"
    ];
});

const showOptionsList = computed(() => {
    return (
        hasOptions.value &&
        (itemCategory.value === "given_definition_choose_word" || itemCategory.value === "given_word_choose_definition")
    );
});

function close() {
    emit("update:modelValue", false);
    emit("close");
}

function goToPreviousBlockedAttempt() {
    if (!canGoPrev.value) return;
    blockedAttemptIndex.value -= 1;
}

function goToNextBlockedAttempt() {
    if (!canGoNext.value) return;
    blockedAttemptIndex.value += 1;
}

function getOptionLetter(idx: number): string {
    return ALPHABET[idx] || "?";
}

// function openFullExplanationAgain() {
//     emit("open-full-explanation");
// }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(LingoModal, {
    modelValue: internalValue.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((internalValue).value = $event)),
    "show-close-button": true,
    "close-on-overlay": true,
    centered: true,
    size: "md",
    class: _normalizeClass(['word-detail-modal', { 'word-detail-modal--blocked': isBlockedAggregateReview.value }])
  }, {
    header: _withCtx(() => [
      (isBlockedAggregateReview.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("p", _hoisted_3, _toDisplayString(blockedAggregateTitle.value), 1),
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("span", _hoisted_5, _toDisplayString(formattedTimestamp.value), 1)
              ])
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("button", {
              class: "answer-review__back",
              type: "button",
              onClick: close,
              "aria-label": "Back to activity"
            }, _hoisted_8),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("p", _hoisted_10, [
                _createElementVNode("span", _hoisted_11, _toDisplayString(wordLabel.value), 1),
                _createElementVNode("span", _hoisted_12, _toDisplayString(displayWord.value ? displayWord.value : "—"), 1)
              ]),
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("span", _hoisted_14, _toDisplayString(formattedTimestamp.value), 1)
              ])
            ])
          ]))
    ]),
    footer: _withCtx(() => [
      (isBlockedAggregateReview.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_64, [
            _createElementVNode("div", _hoisted_65, [
              _createElementVNode("button", {
                class: "answer-review__nav-btn",
                type: "button",
                disabled: !canGoPrev.value,
                onClick: goToPreviousBlockedAttempt,
                "aria-label": "Previous question"
              }, _hoisted_69, 8, _hoisted_66),
              _createElementVNode("span", _hoisted_70, _toDisplayString(blockedDisplayIndex.value) + "/" + _toDisplayString(blockedTotalQuestions.value), 1),
              _createElementVNode("button", {
                class: "answer-review__nav-btn",
                type: "button",
                disabled: !canGoNext.value,
                onClick: goToNextBlockedAttempt,
                "aria-label": "Next question"
              }, _hoisted_74, 8, _hoisted_71)
            ]),
            _createElementVNode("button", {
              class: "answer-review__close-btn",
              onClick: close
            }, "Close")
          ]))
        : (_openBlock(), _createElementBlock("button", {
            key: 1,
            class: "answer-review__close-btn",
            onClick: close
          }, "Close"))
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_15, [
        (isBlockedAggregateReview.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
              (currentBlockedAttempt.value)
                ? (_openBlock(), _createElementBlock("section", _hoisted_17, [
                    _createElementVNode("h3", _hoisted_18, " Question " + _toDisplayString(blockedDisplayIndex.value) + ": ", 1),
                    _createElementVNode("div", _hoisted_19, [
                      (typeof currentBlockedAttempt.value.questionHtml === 'string' && currentBlockedAttempt.value.questionHtml.trim().length)
                        ? (_openBlock(), _createElementBlock("p", {
                            key: 0,
                            class: "answer-review__question-text answer-review__question-text--rich",
                            innerHTML: currentBlockedAttempt.value.questionHtml
                          }, null, 8, _hoisted_20))
                        : (typeof currentBlockedAttempt.value.questionText === 'string' && currentBlockedAttempt.value.questionText.trim().length)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_21, _toDisplayString(currentBlockedAttempt.value.questionText), 1))
                          : _createCommentVNode("", true),
                      (Array.isArray(currentBlockedAttempt.value.questionDetails) && currentBlockedAttempt.value.questionDetails.length)
                        ? (_openBlock(), _createElementBlock("dl", _hoisted_22, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(currentBlockedAttempt.value.questionDetails, (detail) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: `blocked-${blockedDisplayIndex.value}-${detail.label}`,
                                class: "answer-review__detail-row"
                              }, [
                                _createElementVNode("dt", _hoisted_23, _toDisplayString(detail.label) + ":", 1),
                                (detail.isHtml)
                                  ? (_openBlock(), _createElementBlock("dd", {
                                      key: 0,
                                      class: "answer-review__detail-value answer-review__detail-value--rich",
                                      innerHTML: detail.value
                                    }, null, 8, _hoisted_24))
                                  : (_openBlock(), _createElementBlock("dd", _hoisted_25, _toDisplayString(detail.value), 1))
                              ]))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("section", _hoisted_26, [
                      _hoisted_27,
                      _createElementVNode("div", {
                        class: _normalizeClass([
                            'answer-review__answer-card',
                            currentBlockedAttempt.value.isCorrect
                                ? 'answer-review__answer-card--correct'
                                : 'answer-review__answer-card--incorrect'
                        ])
                      }, [
                        _createElementVNode("span", _hoisted_28, _toDisplayString(currentBlockedAttempt.value.studentAnswer || "—"), 1)
                      ], 2)
                    ]),
                    (!currentBlockedAttempt.value.isCorrect)
                      ? (_openBlock(), _createElementBlock("section", _hoisted_29, [
                          _hoisted_30,
                          _createElementVNode("div", _hoisted_31, [
                            _createElementVNode("span", _hoisted_32, _toDisplayString(currentBlockedAttempt.value.correctAnswer || "—"), 1)
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_33, [
              _createElementVNode("section", _hoisted_34, [
                _hoisted_35,
                _createElementVNode("div", _hoisted_36, [
                  (shouldRenderQuestionHtml.value)
                    ? (_openBlock(), _createElementBlock("p", {
                        key: 0,
                        class: "answer-review__question-text answer-review__question-text--rich",
                        innerHTML: questionHtml.value
                      }, null, 8, _hoisted_37))
                    : (showQuestionText.value)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_38, _toDisplayString(questionText.value), 1))
                      : _createCommentVNode("", true),
                  (questionDetails.value.length)
                    ? (_openBlock(), _createElementBlock("dl", _hoisted_39, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(questionDetails.value, (detail) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: detail.label,
                            class: "answer-review__detail-row"
                          }, [
                            _createElementVNode("dt", _hoisted_40, _toDisplayString(detail.label) + ":", 1),
                            (detail.isHtml)
                              ? (_openBlock(), _createElementBlock("dd", {
                                  key: 0,
                                  class: "answer-review__detail-value answer-review__detail-value--rich",
                                  innerHTML: detail.value
                                }, null, 8, _hoisted_41))
                              : (_openBlock(), _createElementBlock("dd", _hoisted_42, _toDisplayString(detail.value), 1))
                          ]))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true),
                  (showOptionsList.value && itemCategory.value === 'given_word_choose_definition')
                    ? (_openBlock(), _createElementBlock("ul", _hoisted_43, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(optionEntries.value, (option, idx) => {
                          return (_openBlock(), _createElementBlock("li", {
                            key: option.id
                          }, [
                            _createElementVNode("span", _hoisted_44, _toDisplayString(getOptionLetter(idx)), 1),
                            _createElementVNode("span", _hoisted_45, _toDisplayString(option.text), 1)
                          ]))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true),
                  (showOptionsList.value && itemCategory.value === 'given_definition_choose_word')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(optionEntries.value, (option, idx) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: option.id,
                            class: "answer-review__options-grid-item"
                          }, [
                            _createElementVNode("span", _hoisted_47, _toDisplayString(getOptionLetter(idx)), 1),
                            _createElementVNode("span", _hoisted_48, _toDisplayString(option.text), 1)
                          ]))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("section", _hoisted_49, [
                _createElementVNode("h3", _hoisted_50, [
                  _createTextVNode(" Student's answer "),
                  (isAnswerCorrect.value)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_51, "(correct)"))
                    : _createCommentVNode("", true)
                ]),
                (useClozeStudentSentence.value)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: _normalizeClass([
                        'answer-review__sentence-card',
                        isAnswerCorrect.value ? 'answer-review__sentence-card--correct' : 'answer-review__sentence-card--incorrect'
                    ])
                    }, [
                      (studentSentenceHtml.value)
                        ? (_openBlock(), _createElementBlock("span", {
                            key: 0,
                            class: "answer-review__sentence-text answer-review__sentence-text--rich",
                            innerHTML: studentSentenceHtml.value
                          }, null, 8, _hoisted_52))
                        : (_openBlock(), _createElementBlock("span", _hoisted_53, _toDisplayString(studentSentenceText.value), 1))
                    ], 2))
                  : (_openBlock(), _createElementBlock("div", {
                      key: 1,
                      class: _normalizeClass(studentAnswerCardClass.value)
                    }, [
                      (showStudentPrefix.value)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_54, _toDisplayString(studentPrefix.value), 1))
                        : _createCommentVNode("", true),
                      _createElementVNode("span", _hoisted_55, _toDisplayString(studentAnswer.value), 1)
                    ], 2))
              ]),
              (!isAnswerCorrect.value)
                ? (_openBlock(), _createElementBlock("section", _hoisted_56, [
                    _hoisted_57,
                    (useClozeCorrectSentence.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                          (correctSentenceHtml.value)
                            ? (_openBlock(), _createElementBlock("span", {
                                key: 0,
                                class: "answer-review__sentence-text answer-review__sentence-text--rich",
                                innerHTML: correctSentenceHtml.value
                              }, null, 8, _hoisted_59))
                            : (_openBlock(), _createElementBlock("span", _hoisted_60, _toDisplayString(correctSentenceText.value), 1))
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_61, [
                          (showCorrectPrefix.value)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_62, _toDisplayString(correctPrefix.value), 1))
                            : _createCommentVNode("", true),
                          _createElementVNode("span", _hoisted_63, _toDisplayString(correctAnswer.value), 1)
                        ]))
                  ]))
                : _createCommentVNode("", true)
            ]))
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "class"]))
}
}

})